import axios, { Axios, AxiosRequestConfig } from 'axios';
import baseUrl from './baseUrl';

import injectCancel from './interceptor/cancel';
import injectResult from './interceptor/result';
import interceptors from './interceptor/interceptors';
import statusCodeInterceptor from './interceptor/statusCode';
function createAxios(baseURL: string, config?: AxiosRequestConfig): Axios {
    const defaultOptions: AxiosRequestConfig = {
        baseURL: baseURL,
        ...config,
    };

    return axios.create(defaultOptions);
}
const wsuiAxios = createAxios(baseUrl.wsui);


// 拦截器 响应顺序    request 先注入的 最后执行    response 先注入的先执行
/* workbenchAxios 注入start  */
statusCodeInterceptor(wsuiAxios); // 状态码拦截器 - 优先处理错误码
interceptors(wsuiAxios);
injectCancel(wsuiAxios);
injectResult(wsuiAxios);
/* workbenchAxios 注入end  */

export default { wsuiAxios };
